// TheGamesDB's /Regions list — https://api.thegamesdb.net/v1/Regions
export const REGION_LABELS = {
  1: "NTSC", 2: "NTSC-U", 3: "NTSC-C", 4: "NTSC-J", 5: "NTSC-K",
  6: "PAL", 7: "PAL-A", 8: "PAL-B", 9: "Other",
};
